// extracted by mini-css-extract-plugin
export default {"btn":"Submit_btn__iXC3R"};